import jwtManager from '@/utility/JwtManager'
import logger from '@/utility/Logger'

function MetaConfig () {
  this.metaTags = {}
}

MetaConfig.prototype.get = function (metaName) {
  if (!(metaName in this.metaTags)) {
    let metaValue = document.head.querySelector('meta[name="' + metaName + '"]')

    if (metaValue === null) {
      logger.error(metaName + ' Meta Value Does Not Exist')

      metaValue = {
        content: ''
      }
    }

    this.metaTags[metaName] = metaValue.content

    console.log('MetaData', metaName, metaValue)
  }

  return this.metaTags[metaName]
}

MetaConfig.prototype.getAuthToken = function () {
  let rawToken = this.get('auth_token')

  if (!jwtManager.isValid(rawToken)) {
    return ''
  }

  return rawToken
}

MetaConfig.prototype.getApiUrl = function () {
  return this.get('api_url')
}

MetaConfig.prototype.getUiUrl = function () {
  return this.get('ui_url')
}

MetaConfig.prototype.getSocketUrl = function () {
  return this.get('socket_url')
}

const metaInstance = new MetaConfig()

export default metaInstance
